import { MobileAppMetadata } from '@quadminds/shared/tracking-system';
import { ICarrierSchema } from './carrier-schema.interface';
import { ISemitrailerSchema } from './semitrailer-schema.interface';
import { ITagsSchema } from './tags-schema.interface';
import { ExternalVehicleAllowedActions } from '../../enums';
import { DeviceReportStatusEnum } from '../../enums/device-report-status.enum';

interface IDeviceLastReportSchema {
    latitude: string | null;
    longitude: string | null;
    geocodedPosition?: string | null;
    timestamp: string | null;
}

export interface IDeviceSchema {
    type: string;
    code: string;
    reportStatus?: DeviceReportStatusEnum;
    lastReport?: IDeviceLastReportSchema | null;
    trackerType?: string;
    lastReportDate?: string;
    metadata: MobileAppMetadata;
}

interface IVehicleDetails {
    engineType?: string;
    maxWeight?: number;
    emptyWeight?: number;
    modelYear?: number;
    brand?: string;
    model?: string;
}

export interface IVehicleAssociatedOrganizations {
    organizationId: string;
    orgLocalName: string;
    orgLocalId: string;
}
export interface IVehicleSchema {
    id: string;
    organizationId?: string;
    name: string;
    type: string;
    code?: string;
    externalId?: string;
    licensePlate: string;
    carrier?: ICarrierSchema;
    tags?: string[] | ITagsSchema[] | null;
    status: string;
    device: IDeviceSchema;
    details?: IVehicleDetails | null;
    createdAt?: string;
    updatedAt?: string;
    hasDevice?: boolean;
    isExternal?: boolean;
    orgsWithFullAccess?: IVehicleAssociatedOrganizations[];
    allowedActions?: ExternalVehicleAllowedActions[];
    semitrailers?: ISemitrailerSchema[] | null;
}
